import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";

function formatMoney(v) {
  if (v == null || v === "") return "—";
  const n = Number(String(v).replace(/\./g, "").replace(",", "."));
  if (!Number.isFinite(n)) return String(v);
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export default function BPeEmittedMessage({ message, t }) {
  const bpe = message?.bpe || {};
  const loc = bpe.localizador || bpe.reservationId || "—";
  const num = bpe.numeroBPe || "—";
  const pol = bpe.poltrona || "—";
  const valor = formatMoney(bpe.valor);
  const route =
    bpe.origem && bpe.destino ? `${bpe.origem} → ${bpe.destino}` : null;

  return (
    <Box
      sx={(theme) => ({
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 1.5,
        p: 1.25,
        bgcolor: theme.palette.mode === "dark" ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.02)",
      })}
    >
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.75 }}>
        <ConfirmationNumberOutlinedIcon fontSize="small" color="primary" />
        <Typography variant="subtitle2" fontWeight={700}>
          {t ? t("messageHistory.bpeEmitted.title") : "BPe emitido"}
        </Typography>
        <Chip size="small" label={t ? t("messageHistory.bpeEmitted.chip") : "Passagem"} color="primary" variant="outlined" />
      </Stack>
      {route && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          {route}
        </Typography>
      )}
      <Typography variant="body2">
        {t ? t("messageHistory.bpeEmitted.locator") : "Localizador"}: <strong>{loc}</strong>
      </Typography>
      <Typography variant="body2">
        {t ? t("messageHistory.bpeEmitted.number") : "Nº BPe"}: {num} ·{" "}
        {t ? t("messageHistory.bpeEmitted.seat") : "Poltrona"}: {pol} ·{" "}
        {t ? t("messageHistory.bpeEmitted.amount") : "Valor"}: {valor}
      </Typography>
    </Box>
  );
}
